import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { CardFinancingModal } from "../components/CardFinancingModal";
import { getDinero } from "../utils/money";

type IProps = Immutable<templates.CardFinancingModalTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <CardFinancingModal
            price={getDinero(props.price)}
            title={props.title}
            linkText={t`Financing available with qualifying order.`}
        />
    );
};
